import { ComponentType, FC } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import * as Icons from '~/icons';

type IconComp = ComponentType<Record<string, unknown>>;

const IconCard: FC<{ name: string; Icon: IconComp }> = ({ name, Icon }) => (
  <Stack spacing={1} alignItems="center">
    <Box>
      <Icon />
    </Box>
    <Typography variant="caption">{name}</Typography>
  </Stack>
);

const IconsPage = () => {
  const entries = Object.entries(Icons).sort(([a], [b]) => a.localeCompare(b));

  return (
    <Box p={4}>
      <Typography>Icons</Typography>
      <Grid container spacing={2}>
        {entries.map(([name, Icon]) => (
          <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }} key={name}>
            <IconCard name={name} Icon={Icon as IconComp} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default IconsPage;
